var Common = new App();

(function () {
	var init = Common.init;

	_.extend(Common, {
		container: null,
		idevice: /ip(hone|ad|od)/i.test(navigator.userAgent),
		url: location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '') + (location.pathname ? location.pathname : '/'),
		isOldIE: $('html').hasClass('lt-ie10'),

		init: function () {
			init.apply(this, arguments);
		},

		// Функция-обертка над requestWrapper()
		request: function(model, params, callback, action, uniqueness) {
			var self = this;

			if (window.amplify) {
				var key = action + ((JSON.stringify(params) || '').replace(/[\W]/g, '')),
					data = amplify.store(key);

				// Сброс кеша, если время кеширования равно нулю или не указано
				if (!(model.cache && model.cache[action])) {
					amplify.store(key, null);
				}
			}

			if (data) {
				data = JSON.parse(data);
				this.parse(data.xhr.response, data.xhr, params, model);
				if (callback && typeof callback === 'function') {
					callback(data.xhr.response, data.xhr, params);
				}
			} else {
				var method = params && params._method,
					notBlockable = params && params._notBlockable,
					notTriggerErrors = params && params._notTriggerErrors,
					onStartLoadingHandler = params && params._onStartLoadingHandler;
					// TODO: Не работает логика блокирования отправки повторных запросов. Нужно порефакторить логику запросов.
					//synchronous = params && params._synchronous;

				if (params) {
					delete(params._notBlockable);
					delete(params._method);
					delete(params._onStartLoadingHandler);
					delete(params._notTriggerErrors);
					//delete(params._synchronous);
				}

				var options = {
					key: key,
					cache: (model.cache && model.cache[action]) * 1000 || 0,
					beforeSend: function(xhr, settings) {
						if (!Common.validate(model, action, params)) {
							xhr.abort();

							//delete self._req[uniqueness];
						} else {
							this.data = JSON.stringify(params);
							xhr.setRequestHeader('x-date-format', 'iso');

							if (options && options.headers) {
								for (var key in options.headers) {
									xhr.setRequestHeader(key, options.headers[key]);
								}
							}

							onStartLoadingHandler && onStartLoadingHandler();
							Common.view.showPreloader && Common.view.showPreloader(notBlockable);
						}
					},
					success: function(model, response, xhr) {
						if (callback && typeof callback === 'function') {
							callback(response, xhr, params);
						}
					},
					notTriggerErrors: notTriggerErrors
				};

				if (params && params.options) {
					_.extend(options, params.options);

					delete(params.options);
				}

				Common.requestWrapper(model, method === 'GET' ? 'read' : 'send', params, {
					action: action,
					uniqueness: uniqueness == undefined ? action : uniqueness,
					//synchronous: synchronous,
					options: options
				});
			}
		},

		// Вспомогательный общий метод для метода parse() моделей
		parse: function(response, xhr, params, model) {
			xhr.userData || (xhr.userData = {});

			var actionName = xhr.userData.action,
				actionList = model.actions,
				action = actionList[actionName || model.action] || function() {};

			model.action = null;

			if (response) {
				if (response.success || response.isSuccessfull) {
					action.apply(model, arguments);
				} else {
					var message = response.message;

					if (typeof message.length !== 'undefined') {
						model.trigger('error', {
							messages: [message]
						}, model, actionName);
					}
				}
			}

			// Не останавливаем прелоадер, если есть еще ajax-запросы в очереди
			if ($.active <= 1) {
				Common.view.hidePreloader && Common.view.hidePreloader();
			}
		},

		// Метод, регистрирующий шаблоны-паршелы для Handlebars
		registerHandlebarsPartials: function($elements) {
			$elements.each(function() {
				var $this = $(this),
					name = $this.attr('id').replace(/^ui\_/, '');

				Handlebars.registerPartial(name, Handlebars.compile($('#ui_' + name, this.$el).html()));
			});
		},

		// Метод для валидации параметров запросов до отправки их на сервер
		validate: function(model, action, params) {
			var validationFails = false,
				validationMessages = [],
				validationFields = [],
				validationFieldsMessages = {},
				serviceRules, isSilent;

			if (params) {
				if (params.ignoreValidation) {
					delete (params.ignoreValidation);
				} else {
					serviceRules = model.validatorRules ? model.validatorRules[action] : null,
					isSilent = params.isSilent;

					delete (params.isSilent);

					if (serviceRules) {
						var keys = _.keys(serviceRules);

						if (params.validateExceptionFields) {
							keys = _.difference(keys, params.validateExceptionFields);
						}

						for (var i = 0, imax = keys.length; i < imax; i++) {
							var name = keys[i],
								validator = serviceRules[name];

							if (validator) {
								for (var j = 0, jmax = validator.rules.length; j < jmax; j++) {
									var rule = validator.rules[j],
										namesArray = name.split('.'),
										paramValue = namesArray.length > 1 ? params[namesArray[0]][namesArray[1]] : params[name];

									/**
									 * Одна логика по валидации нескольких полей одним правилом,
									 * при котором валидируется действительно несколько полей
									 * и подсветятся все.
									 */
									if (typeof paramValue === 'undefined') {
										namesArrays = name.split(', ');

										if (namesArrays.length > 1) {
											paramValue = [];

											_.each(namesArrays, function (name) {
												paramValue.push(params[name]);
											});
										}
									}

									/**
									 * Другая логика по валидации нескольких полей одним правилом,
									 * при котором валидируется одно поле, но при валидации учитывается несколько полей.
									 * Подсвечивается одно поле.
									 */ 
									if (validator.requiredFields) {
										paramObj = {};

										paramObj[name] = paramValue;

										for (var p = 0, pmax = validator.requiredFields.length; p < pmax; p++) {
											var requiredFieldName = validator.requiredFields[p];

											paramObj[requiredFieldName] = params[requiredFieldName];
										}

										paramValue = paramObj;
									}

									if (typeof paramValue !== 'undefined') {
										var result = Common.validators[rule](paramValue);

										if (!result.status) {
											var validatorMessage = (_.isFunction(validator.message) ? validator.message() :
																	_.isObject(validator.message) ? validator.message[rule] :
																	validator.message) || result.message;

											if (result.fields) {
												for (var k = 0, kmax = result.fields.length; k < kmax; k++) {
													validationFieldsMessages[result.fields[k]] = validatorMessage;
												}
											} else {
												validationFieldsMessages[name] = validatorMessage;
											}

											validationMessages.push(validatorMessage);
											validationFields = _.union(validationFields, result.fields || [name]);
											validationFails = true;
											break;
										} else {
											if (result.value) {
												if (namesArray.length > 1) {
													params[namesArray[0]][namesArray[1]] = result.value;
												} else {
													params[name] = result.value;
												}
											}
										}
									}
								}
							}
						}

						delete (params.validateExceptionFields);
					}
				}
			}

			var errorsObj = {
					messages: validationMessages,
					fields: validationFields,
					fieldsMessages: validationFieldsMessages
				};

			if (isSilent) {
				return errorsObj;
			} else {
				if (validationFails) {
					model.trigger('error', errorsObj, model, action);
				}

				return !validationFails;
			}
		},

		// Общие правила для валидаторов
		validators: {
			required: function(value) {
				return {
					status: !!$.trim(value),
					message: 'Поле не должно быть пустым'
				}
			}
		},

		checkActiveViewByCID: function (view) {
			try {
				return Common.get(view.__bundleName).view.cid === view.cid;
			} catch (e) {
				return true;
			}
		},
	});
})();
